import { z } from "zod";

import { ldoApiV1 } from "../api";

const rasterPointSchema = z.object({
  results: z.array(z.object({ value: z.number().nullable() })),
});

export const getRasterPointValue = (
  scenarioId: number,
  rasterId: string,
  lng: number | null,
  lat: number | null
) =>
  ldoApiV1.getQueryOptions({
    queryKey: ["scenarios", scenarioId, "point", rasterId, "point", lng, lat],
    queryFn: async (): Promise<number | null> => {
      const pointWkt = `POINT (${lng ?? 0} ${lat ?? 0})`;
      const response = rasterPointSchema.parse(
        await ldoApiV1.fetchJson(`/scenarios/${scenarioId}/point/${rasterId}/${pointWkt}`)
      );
      console.log("RESPONSE", response);
      if (response.results.length > 0) {
        return response.results[0].value;
      } else {
        return null;
      }
    },
    enabled: scenarioId !== -1 && rasterId !== "" && lng !== null && lat !== null,
  });
